"use client"

import { useState, useEffect } from "react"
import styles from "../../styles/shared-module-css/Modal.module.css"

const Modal = ({ title, children, footer, isOpen: externalIsOpen, onClose, width, height }) => {
  const [isOpen, setIsOpen] = useState(externalIsOpen || false)

  useEffect(() => {
    if (externalIsOpen !== undefined) {
      setIsOpen(externalIsOpen)
    }
  }, [externalIsOpen])

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"
    }
    return () => {
      document.body.style.overflow = "unset"
    }
  }, [isOpen])

  const closeModal = () => {
    setIsOpen(false)
    if (onClose) onClose()
  }

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        closeModal()
      }
    }
    if (isOpen) {
      document.addEventListener("keydown", handleEsc)
    }
    return () => {
      document.removeEventListener("keydown", handleEsc)
    }
  }, [isOpen])

  if (!isOpen) return null

  return (
    <div className={styles.modal_overlay} onClick={closeModal}>
      <div
        className={styles.modal_container}
        onClick={(e) => e.stopPropagation()}
        style={{
          "--modal-width": width || "90%",
          "--modal-height": height || "90vh",
        }}
      >
        <div className={styles.modal_header}>
          <h3 className={styles.modal_title}>{title}</h3>
          <button className={styles.modal_close_btn} onClick={closeModal} aria-label="Close modal">
            &times;
          </button>
        </div>

        <div className={styles.modal_body}>{children}</div>

        {footer && <div className={styles.modal_footer}>{footer}</div>}
      </div>
    </div>
  )
}

export default Modal
